import script from "./Schedule.vue?vue&type=script&lang=ts&setup=true"
export * from "./Schedule.vue?vue&type=script&lang=ts&setup=true"

import "./Schedule.vue?vue&type=style&index=0&id=9aa961c4&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9aa961c4"]])

export default __exports__